/**
 * Shared styles for project tabs (Requirements, Test Cases, Prompts, Team) and
 * the Knowledge Base pages. Centralised so every tab reads as one design system.
 */
import { makeStyles } from '@material-ui/core/styles';

export const useTabStyles = makeStyles(theme => ({
  scroll: {
    flex: 1,
    minHeight: 0,
    overflowY: 'auto',
    paddingRight: theme.spacing(0.5),
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(1.5),
    marginBottom: theme.spacing(2),
    flexWrap: 'wrap',
  },
  toolbarTitle: {
    fontSize: '0.95rem',
    fontWeight: 700,
    color: theme.palette.text.primary,
  },
  toolbarSub: { fontSize: '0.8rem', color: theme.palette.text.secondary },
  primaryBtn: {
    height: 34,
    padding: theme.spacing(0, 1.75),
    borderRadius: theme.shape.borderRadius * 1.5,
    border: 'none',
    background: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    fontSize: '0.8rem',
    fontWeight: 600,
    cursor: 'pointer',
    display: 'inline-flex',
    alignItems: 'center',
    gap: theme.spacing(0.75),
    '&:hover': { background: theme.palette.primary.dark },
    '&:focus-visible': {
      outline: `2px solid ${theme.palette.secondary.main}`,
      outlineOffset: 2,
    },
  },

  // Card list
  list: { display: 'flex', flexDirection: 'column', gap: theme.spacing(1.25) },
  card: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),
    padding: theme.spacing(1.75, 2),
    borderRadius: theme.shape.borderRadius * 2,
    background: theme.palette.background.paper,
  },
  cardMain: { flex: 1, minWidth: 0 },
  cardTitle: {
    fontSize: '0.88rem',
    fontWeight: 600,
    color: theme.palette.text.primary,
  },
  cardSub: {
    fontSize: '0.78rem',
    color: theme.palette.text.secondary,
    marginTop: 2,
  },
  cardMeta: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),
    flexShrink: 0,
  },

  // Status / type badges
  badge: {
    fontSize: '0.68rem',
    fontWeight: 600,
    padding: '3px 9px',
    borderRadius: 12,
    background: theme.palette.action.selected,
    color: theme.palette.text.secondary,
    whiteSpace: 'nowrap',
  },
  badgeSuccess: {
    background: 'rgba(31,199,182,0.15)',
    color: theme.palette.secondary.main,
  },
  badgeInfo: {
    background: 'rgba(76,141,255,0.15)',
    color: theme.palette.primary.main,
  },
  badgeWarn: {
    background: 'rgba(255,176,32,0.15)',
    color: '#d98a00',
  },

  avatar: {
    width: 36,
    height: 36,
    minWidth: 36,
    borderRadius: '50%',
    background: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '0.8rem',
    fontWeight: 600,
  },

  empty: {
    color: theme.palette.text.secondary,
    fontSize: '0.85rem',
    padding: theme.spacing(3, 0),
    textAlign: 'center',
  },
}));
